<div class="container">
  <header class="header">
    <picture class="picture">
      <source
        srcset="{{ olciUrlprefix }}{{ brandName() }}-health-center-small-1x.png 1x, {{ olciUrlprefix }}{{ brandName() }}-health-center-small-2x.png 2x"
        media="(max-width: 500px)"
        />
      <img
        srcset="{{ olciUrlprefix }}{{ brandName() }}-health-center-1x.png 1x, {{ olciUrlprefix }}{{ brandName() }}-health-center-2x.png 2x"
        alt="{{ brandName() }} health center"
        class="picture__image"
        />
    </picture>

    <div class="card">
      <div class="card__summary">
        <div class="card__title">{{ bundle() && bundle()['label.healthcenter.healthycruising.header'] }}</div>
        <div class="text">{{ bundle() && bundle()['label.healthcenter.healthycruising.subcopy'] }}</div>
      </div>
      <div class="card__sailing">
        <div class="card__field">
          <div class="card__field-label">{{ bundle() && bundle()['label.healthcenter.ship'] }}</div>
          <div class="card__field-value">{{ sailing().shipName | titlecase }}</div>
        </div>
        <div class="card__field">
          <div class="card__field-label">{{ bundle() && bundle()['label.healthcenter.saildates'] }}</div>
          <div class="card__field-value">
            {{ sailing().sailDateStart | date: 'MMMM d' }} &mdash; {{ sailing().sailDateEnd | date: sailing().dateFormat }}
          </div>
        </div>
      </div>
    </div>
  </header>

  <main class="protocols">
    <h1 class="protocols__title">{{ bundle() && bundle()['label.healthcenter.preparing.header'] }}</h1>
    <div class="text">{{ bundle() && bundle()['label.healthcenter.preparing.subcopy'] }}</div>
    <ul class="protocols__list">
      @for (protocol of protocols; track protocol) {
        <li class="protocol-card">
          <img class="protocol-card__icon" src="{{ urlPrefix() }}/images{{ protocol.icon }}" alt="{{ brandName() }} health icon" />
          <div class="protocol-card__info">
            <div class="protocol-card__info-heading">{{ protocol.heading }}</div>
            <div class="text">{{ protocol.content }}</div>
            @if (protocol.url && protocol.linkText) {
              <div>
                <a (click)="onClickExternalLink(protocol.linkText)" class="link link_{{ brandName() }}" [href]="protocol.url" target="_blank" rel="noopener">{{ protocol.linkText }}</a>
              </div>
            }
          </div>
        </li>
      }
    </ul>
  </main>
</div>
